<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/products/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  props: ['cancel_url'],
  data() {
    return {
      formRoute: route('api.v1.products.store'),
      redirectRoute: '',
      stayOnPageRedirect: route('products.edit', {product: '_id_'}),
    }
  },
  mounted() {
    this.redirectRoute = this.cancel_url;
  }
}
</script>

<template>
  <App title="Product toevoegen">
    <form id="productForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="productForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>